/* Wait for the hero entrance, then reveal the brush from its left edge. */
(() => {
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const pending=new Map();const ready=new WeakSet(), images=new WeakSet();let queued=false;
  function draw(element){
    const delay=element.matches('.vnk-hero-prices')?900:100;
    const timer=setTimeout(()=>{
      pending.delete(element);if(!element.isConnected)return;
      requestAnimationFrame(()=>requestAnimationFrame(()=>element.classList.add('vnk-ink-drawn')));
    },delay);
    pending.set(element,timer);
  }
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){observer.unobserve(entry.target);draw(entry.target);}});
  },{threshold:.4}):null;
  function init(){
    queued=false;
    document.querySelectorAll('.vnk-card-hover-image').forEach(frame=>{
      if(images.has(frame))return;
      const image=frame.querySelector('img');if(!image)return;images.add(frame);
      const loaded=async()=>{if(!image.naturalWidth)return;try{await image.decode();}catch{}if(!image.naturalWidth)return;image.classList.remove('is-loading');image.closest('.image-wrapper')?.classList.remove('is-loading');frame.setAttribute('data-vnk-image-ready','');};
      if(image.complete)loaded();else image.addEventListener('load',loaded,{once:true});
    });
    document.querySelectorAll('.vnk-hero-prices').forEach(element=>{
      if(!element.matches('.vnk-hero-prices')&&element.textContent.trim()!=='Stöbere nach Marke')return;
      if(ready.has(element))return;ready.add(element);
      if(!element.matches('.vnk-hero-prices'))element.classList.add('vnk-brand-scroll-title');
      if(!observer||motion.matches)return;
      element.classList.add('vnk-ink-ready');element.getBoundingClientRect();observer.observe(element);
    });
  }
  function start(){init();new MutationObserver(records=>{
    if(records.some(record=>record.addedNodes.length)&&!queued){queued=true;requestAnimationFrame(init);}
  }).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.vnk-ink-ready').forEach(element=>{observer?.unobserve(element);clearTimeout(pending.get(element));pending.delete(element);}));
  motion.addEventListener('change',()=>{if(motion.matches){pending.forEach(clearTimeout);pending.clear();document.querySelectorAll('.vnk-ink-ready').forEach(element=>element.classList.add('vnk-ink-drawn'));}});
})();
